//GLOBAL - components from npm
import React from "react";

//STYLES
import "./h1.css";

//COMPONENTS

//SERVICES - api, conectors...

//GLOBAL STATE - redux, env...

//ASSETS - icons, images...

export default function H1({ className, children, weight, color }) {
  //GENERAL
  const mainClassName = "typography-h1";

  //STATES

  //REDUX - Selectors

  //FUNCTIONS

  //USE EFFECTS

  return (
    <h1
      className={`${mainClassName} ${className ? className : ""} ${
        weight ? `${mainClassName}--${weight}` : ""
      } ${color ? `${mainClassName}--color-${color}` : ""}`}
    >
      {children}
    </h1>
  );
}
